import React, {Component} from 'react'
import Link from "gatsby-link";
import Navbar from '../components/navbar'
import MobileContent from '../components/mobile-content'
import {FORM_STYLES} from '../components/assets/forms-shared'
import { colors, spacing, shadows, typography } from '../components/assets/shibui';
import SS from '../components/assets/shared-styles'
import Helmet from 'react-helmet'
import { TwitterSVG } from '../components/assets/icons'
import '../../src/layouts/main.css'

const S = {
  blogHeaderWrap: {
    ...SS.flexCenter,
    width: '100%',
    textAlign: 'center',
    marginTop: spacing.lg
  },
  blogWrap: {
    marginTop: 0,
    width: '100%',
    color: colors.seattle50.color,
    minHeight: 200,
    display: 'inline-block',
    padding: '60px 10px 100px',
  },
  blogContentWrap:{
    margin: '0 auto',
    backgroundColor: 'rgb(252,252,252)',
    borderRadius: 12,
    width: '98%',
    maxWidth: 980,
    minWidth: 300,
    padding: '20px 46px 20px',
    minHeight: 'calc(100vh - 260px)',
    boxShadow: shadows.modal.boxShadow,
  },
  keepReadingWrap:{
    margin: '0 auto',
    width: '98%',
    maxWidth: 980,
    minWidth: 300,
  },
  link: {
    textDecoration: 'none'
  },
  authorWrap: {
    textAlign: 'center',
    display: 'block',
    textDecoration: 'none',
    marginTop: -40,
    fontSize: 16,
  },
  authorHeadshot: {
    backgroundColor: colors.ivory.color,
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    borderRadius: 40,
    height: 60,
    left: 'calc(50% - 30px)',
    top: -50,
    position: 'relative',
    width: 60,
    margin: '0 auto'
  },
  authorName: {
    fontWeight: 'bold',
    marginTop: 7,
    marginBottom: 0,
    color: colors.graphite.color,
    fontSize: 16
  },
  authorBlurb: {
    marginTop: -2,
    marginBottom: 0,
    color: colors.graphite.color,
    fontSize: 16
  },
  twitterContainer: {
    position: 'relative'
  },
  twitterLogo: {
    cursor: 'pointer',
    top: -1,
    position: 'absolute'
  },
  blogPost: {
    fontSize: '1.2rem',
    color: colors.midnight.color
  },
  keepReadingContent: {
    padding: 12
  },
  keepReadingTitle: {
    textTransform: 'uppercase',
    fontSize: 22,
    marginTop: 5,
    marginBottom: 5,
  },
  keepReadingSubtitle: {
    color: colors.midnight.color,
    marginTop: 80,
  },
  keepReadingAuthorWrap: {
    display: 'block',
    textDecoration: 'none',
    position: 'relative',
    minHeight: 50
  },
  keepReadingAuthorHeadshot: {
    backgroundColor: colors.ivory.color,
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    borderRadius: 20,
    position: 'absolute',
    height: 40,
    left: 0,
    bottom: 0,
    width: 40
  },
  keepReadingAuthorName: {
    position: 'absolute',
    bottom: 8,
    left: 50,
    marginBottom: 0,
    color: colors.midnight.color,
    fontSize: 16
  },
  keepReading: {
    backgroundColor: colors.ivory.color,
    paddingBottom: spacing.md,
    height: 'auto'
  },
  tag: {
    fontSize: 14,
    background: colors.amethyst50.color,
    color: colors.ivory.color,
    borderRadius: 4,
    padding: 5,
    marginTop: 15,
    display: 'inline-block'
  },
  ...FORM_STYLES
}

export default class Template extends Component {
  componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0,0)
    })
  }

  render () {
    const { data, pathContext } = this.props;
    const { markdownRemark: post } = data; // data.markdownRemark holds our post data
    const { next, prev } = pathContext;

    return (
      <div>

        <Helmet>
          <title>{`Haiku Blog - ${post.frontmatter.title}`}</title>
          {post.excerpt && <meta name="description" content={post.excerpt} />}
          {post.frontmatter.canonicalUrl && <link rel="canonical" href={post.frontmatter.canonicalUrl} />}
          {post.frontmatter.title && <meta property="og:title" content={post.frontmatter.title} />}
          {post.excerpt && <meta property="og:description" content={post.excerpt} />}
          {post.frontmatter.coverImage.publicURL && <meta property="og:image" content={`${process.env.SITE_URL}${post.frontmatter.coverImage}`} />}
          {post.frontmatter.path && <meta property="og:url" content={`${process.env.SITE_URL}${post.frontmatter.path}`} />}
        </Helmet>

        <Navbar location="blog" />

        <div style={{
          margin: '0 auto',
          width: '100%'
        }}>

          <div style={S.blogHeaderWrap}>
            <Link to="/blog/">
              <h1 style={{ ...typography.heading1, ...SS.centerer, ...{ margin: `${spacing.sm}px 0 0`, color: colors.midnight.color}}}>Haiku Blog</h1>
              <p style={SS.subtitle}>Articles, videos and resources by the Haiku team.</p>
            </Link>
          </div>

          <div style={S.blogWrap}>
            <div style={S.blogContentWrap}>
              <div className="blog-post-container">
                <img src={post.frontmatter.authorHeadshot} style={S.authorHeadshot} alt={post.frontmatter.authorName}/>
                <div style={S.authorWrap}>
                  <div style={S.authorName}>
                    {post.frontmatter.authorName}
                    { post.frontmatter.twitterLink && <a target="_blank" href={post.frontmatter.twitterLink} style={S.twitterContainer}><span style={S.twitterLogo}><TwitterSVG color="rgb(72,160,236)" /></span></a> }
                  </div>
                  <div style={S.authorBlurb}>{post.frontmatter.authorBlurb}</div>
                </div>
                <div className="blog-post" style={S.blogPost}>
                  <div style={{textAlign:'center', marginTop: 0}}>
                    <h2 style={{...typography.heading2, ...{textAlign: 'center'}}}>{post.frontmatter.title}</h2>
                    <div style={{...S.authorBlurb, ...{marginTop: spacing.md}}}>
                      {post.frontmatter.date}
                      {post.frontmatter.readLength && <span> - {post.frontmatter.readLength} min read</span>}
                    </div>
                    {post.frontmatter.tags && post.frontmatter.tags.map((tag, index) => <span key={`tag${index}`} style={S.tag}>{tag}</span>)}
                  </div>

                    <div
                      className="blog-post-content"
                      dangerouslySetInnerHTML={{ __html: post.html }}
                    >
                    </div>

                </div>


              </div>
            </div>

            <div style={S.keepReadingWrap}>
            <div className="keep-reading">
              {next &&
                <div>
                  <h5 style={S.keepReadingSubtitle}>Previous Post</h5>
                  <Link className="link next" to={next.path}>
                    <div className="keep-reading-block" style={S.keepReading}>
                      <img className="blogFeatureImage" src={next.coverImage.publicURL} alt={next.title}/>
                      <div style={S.keepReadingContent}>
                        <p style={SS.heading5}>{next.title}</p>
                        <div style={S.keepReadingAuthorWrap}>
                          <img src={next.authorHeadshot} style={S.keepReadingAuthorHeadshot} alt={next.authorName}/>
                          <p style={S.keepReadingAuthorName}>{next.authorName}</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>}
                {prev &&
                  <div>
                    <h5 style={S.keepReadingSubtitle}>Next Post</h5>
                    <Link className="link prev" to={prev.path}>
                        <div className="keep-reading-block" style={S.keepReading}>
                          <img className="blogFeatureImage" src={prev.coverImage.publicURL} alt={prev.title}/>
                          <div style={S.keepReadingContent}>
                            <p style={SS.heading5}>{prev.title}</p>
                            <div style={S.keepReadingAuthorWrap}>
                              <img src={prev.authorHeadshot} style={S.keepReadingAuthorHeadshot} alt={prev.authorName}/>
                              <p style={S.keepReadingAuthorName}>{prev.authorName}</p>
                            </div>
                          </div>
                        </div>
                    </Link>
                  </div>}
              </div>
            </div>

          </div>

        </div>

          <MobileContent />

      </div>
    );
  }
  }

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      excerpt
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
        authorHeadshot
        authorName
        authorBlurb
        twitterLink
        canonicalUrl
        coverImage {
          publicURL
        }
        readLength
        tags
      }
    }
  }
`
;



// WEBPACK FOOTER //
// ./src/templates/blog-post.js